<template>
  <div class="h-100 ba-relative" ref="container">
    <router-link
      tag="button"
      type="button"
      class="ba-rounded-full shadow-none ba-p-2 ba-absolute ba-right-0 ba-top-0 ba-z-10"
      :to="{ name: 'List View', params: { mnemonic } }"
    >
      <vis-icon-table-view class="ba-w-5 ba-h-5 ba-text-text-blue-grey hover:ba-text-text-black " />
    </router-link>
    <vis-loading v-if="loading" :loading="loading" class="h-100" />
    <vis-carousel-editor
      @mainClick="onClick"
      v-else
      :items="items"
      :slideWidth="carouselSlideWidth"
      :slideHeight="carouselSlideHeight"
    >
      <template #default="{ item, current, showTitle }">
        <div class="w-100 h-100">
          <b-img :src="item.preview" class="carousel-3d-slide__image"></b-img>
          <div
            v-if="item.Title && showTitle && current"
            class="carousel-3d-slide__title ba-leading-5 ba-absolute ba-bottom-0 ba-px-4 ba-py-2 ba-text-center ba-rounded-lg ba-text-white ba-bg-background-modal-dark"
          >
            {{ item.Title }}
          </div>
        </div>
      </template>
    </vis-carousel-editor>
    <vis-detail-view-dialog
      v-if="detailView.crudService !== null"
      :crud-service="detailView.crudService"
      :visible="detailView.visible"
      @hide="() => (detailView.visible = false)"
    />
  </div>
</template>

<script>
import VisCarouselEditor from "@/views/base/editors/vis-carousel-editor";
import RemoteCrudService from "@/shared/services/remote-crud-service";
import api from "@/api/visary-api";
import filestorageApi from "@/api/filestorage-api";
import debounce from "debounce";

export default {
  name: "vis-doc-carousel",
  components: {
    VisCarouselEditor
  },
  props: {
    mnemonic: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      config: null,
      loading: true,
      items: [],
      detailView: {
        crudService: null,
        visible: false
      },
      carouselSizeFactor: 0.82,
      carouselSlideWidth: undefined,
      carouselSlideHeight: undefined,
      resizeDelay: 200
    };
  },
  computed: {
    doResize() {
      return debounce(this.onResize, this.resizeDelay);
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.updateCarouselSize();
    window.addEventListener("resize", this.doResize);

    if (screen.orientation) {
      screen.orientation.addEventListener("change", this.doResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.doResize);

    if (screen.orientation) {
      screen.orientation.removeEventListener("change", this.doResize);
    }
  },
  methods: {
    async fetchData() {
      this.config = await api.viewConfig.getListView(this.mnemonic);
      await this.getItems();
      this.loading = false;
    },
    async getItems() {
      const response = this.config.Ext.JournalEntity
        ? await api.listView.getJournalData({
            Mnemonic: this.mnemonic,
            PageSize: 100,
            Columns: ["Files", "ID", "Title"]
          })
        : await api.listView.gridData({
            Mnemonic: this.mnemonic,
            PageSize: 100,
            Columns: ["Files", "ID", "Title"]
          });
      this.items = response.Data;
      let previewPromises = this.items
        .filter((item) => item.Files)
        .map((x) => filestorageApi.preview.getPreviewByLink(x.Files?.split(",")[0], "l"));
      let previews = await Promise.all(previewPromises);

      for (let i = 0; i < previews.length; i++) {
        this.items[i].preview = previews[i];
      }
    },
    getJournalEntryData(journalId) {
      let data = journalId.split(".").reverse()[0].split("_");
      return {
        ID: data[1],
        Mnemonic: data[0]
      };
    },
    onClick(item) {
      if (this.config.Ext.JournalEntity) {
        let data = this.getJournalEntryData(item.ID);

        this.detailView.crudService = new RemoteCrudService(data.Mnemonic);
        this.detailView.crudService.setId(data.ID);
      } else {
        this.detailView.crudService = new RemoteCrudService(this.mnemonic);
        this.detailView.crudService.setId(item.ID);
      }

      this.detailView.visible = true;
    },
    updateCarouselSize() {
      this.$nextTick(() => {
        if (this.$refs.container) {
          const {
            width,
            height
          } = this.$refs.container.getBoundingClientRect();

          this.carouselSlideHeight = height * 0.9968;
          this.carouselSlideWidth =
            this.carouselSlideHeight * this.carouselSizeFactor;

          if (this.carouselSlideHeight > height) {
            this.carouselSlideHeight = height;
          }

          if (this.carouselSlideWidth > width) {
            this.carouselSlideWidth = width;
          }
        }
      });
    },
    onResize() {
      this.updateCarouselSize();
    }
  }
};
</script>
